import { render, staticRenderFns } from "./HubRules.vue?vue&type=template&id=608f579e&scoped=true"
import script from "./HubRules.vue?vue&type=script&lang=js"
export * from "./HubRules.vue?vue&type=script&lang=js"
import style0 from "./HubRules.vue?vue&type=style&index=0&id=608f579e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f579e",
  null
  
)

export default component.exports